const routes = {
  root: '/ces-stcw/details',
}

export default routes
